export default __webpack_public_path__ + "static/media/empty-data-4.f32d5cd7.svg";